import { useEffect } from 'react';

const DEFAULT_SITE_URL = 'https://involab.co';

function upsertMetaByName(name) {
  let element = document.head.querySelector(`meta[name="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    document.head.appendChild(element);
  }
  return element;
}

function upsertMetaByProperty(property) {
  let element = document.head.querySelector(`meta[property="${property}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute('property', property);
    document.head.appendChild(element);
  }
  return element;
}

function upsertLink(rel) {
  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  return element;
}

function resolveSiteUrl() {
  const envSiteUrl = process.env.REACT_APP_SITE_URL?.replace(/\/$/, '');

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '') || envSiteUrl || DEFAULT_SITE_URL;
  }

  return envSiteUrl || DEFAULT_SITE_URL;
}

const SeoHead = ({
  title,
  description,
  path = '/',
  robots = 'index,follow',
  imagePath = '/og-image.png',
  type = 'website',
}) => {
  useEffect(() => {
    const siteUrl = resolveSiteUrl();
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    const canonicalUrl =
      normalizedPath === '/' ? `${siteUrl}/` : `${siteUrl}${normalizedPath}`;
    const imageUrl = imagePath.startsWith('http')
      ? imagePath
      : `${siteUrl}${imagePath.startsWith('/') ? imagePath : `/${imagePath}`}`;

    document.title = title;

    upsertMetaByName('description').setAttribute('content', description);
    upsertMetaByName('robots').setAttribute('content', robots);

    upsertMetaByProperty('og:title').setAttribute('content', title);
    upsertMetaByProperty('og:description').setAttribute('content', description);
    upsertMetaByProperty('og:type').setAttribute('content', type);
    upsertMetaByProperty('og:url').setAttribute('content', canonicalUrl);
    upsertMetaByProperty('og:site_name').setAttribute('content', 'Invo');
    upsertMetaByProperty('og:image').setAttribute('content', imageUrl);

    upsertMetaByName('twitter:card').setAttribute('content', 'summary_large_image');
    upsertMetaByName('twitter:title').setAttribute('content', title);
    upsertMetaByName('twitter:description').setAttribute('content', description);
    upsertMetaByName('twitter:image').setAttribute('content', imageUrl);

    upsertLink('canonical').setAttribute('href', canonicalUrl);
  }, [description, imagePath, path, robots, title, type]);

  return null;
};

export default SeoHead;
